import { defineMessages } from "react-intl";

import { ReservationType } from "@/features/bookings/types/types";

export const reservationTypesLabels = defineMessages({
  [ReservationType.PAST]: {
    defaultMessage: "Completed",
    description: "Tab label for completed bookings in My Bookings",
  },
  [ReservationType.UPCOMING]: {
    defaultMessage: "Upcoming",
    description: "Tab label for upcoming bookings in My Bookings",
  },
  [ReservationType.REFUNDED]: {
    defaultMessage: "Cancelled",
    description: "Tab label for cancelled bookings in My Bookings",
  },
});
